<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_order_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="订单号">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="客户">
							<c-select name="customer_ids" async multiple @search="searchCustomer"></c-select>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="支持产品编号/名称/规格"></c-input>
						</m-search-item>
						<m-search-item label="订单状态">
							<c-select name="order_states" :options="salesOrderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="排产状态">
							<c-select name="scheduling_states" :options="schedulingStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="库存占用状态">
							<c-select name="occ_states" :options="occStatedic" multiple></c-select>
						</m-search-item>
						<m-search-item label="要求交货时间" colspan="2">
							<c-datetime range start-name="plan_delivery_start_date" end-name="plan_delivery_end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="完成时间" colspan="2">
							<c-datetime range start-name="finish_start_date" end-name="finish_end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_order_create')" v-lock="lock('b_order_create')" prepend-icon="tf-add" @click="editOrder()">创建销售订单</c-button>
					<c-button v-if="auth('b_order_export')" v-lock="lock('b_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_order_export')" v-lock="lock('b_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>

                    <c-button v-if="auth('b_order_create') || auth('b_order_edit')" v-lock="lock('b_order_create')" prepend-icon="tf-import" @click="importData()">导入</c-button>
                </template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_order_transfer')" v-lock="lock('b_order_transfer')" prepend-icon="tf-order" @click="transferWork(data)">转生产工单</c-button>
					<c-button v-if="auth('b_order_export')" v-lock="lock('b_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_order_export')" v-lock="lock('b_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_order_print')" v-lock="lock('b_order_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_order_log')" v-lock="lock('b_order_log')" prepend-icon="tf-import-record" @click="$refs.view.loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_order_log')" v-lock="lock('b_order_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #order_code="{data}">
					<c-link v-if="auth('b_order_query')" @click="globalDialog('orderDetail', {props: {id: data.id}})">{{data.order_code}}</c-link>
					<span v-else>{{data.order_code}}</span>
				</template>

				<!--产品金额-->
				<template #product_money="{data}">
					￥{{data.product_money}}
				</template>

				<!--订单状态-->
				<template #order_state="{data}">
					<c-state dict="salesOrderStateDic" tag :value="data.order_state"></c-state>
				</template>
				
				<!--排产状态-->
				<template #scheduling_state="{data}">
					<c-state dict="schedulingStateDic" :value="data.scheduling_state"></c-state>
				</template>
				
				<!--库存占用状态-->
				<template #occ_state="{data}">
					<template v-if="data.order_state == 2">
						<c-switch v-if="auth('b_order_occ')" v-model="data.occ_state" :state-value="[2, 1]" :state-text="['已占用','未占用']" @beforeChange="occStateHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="occStatedic" :value="data.occ_state"></c-state>
					</template>
					<span v-else>-</span>
				</template>
				
				<!--交货进度%-->
				<template #deliver_progress="{data}">
					<c-progress :rate="[data.deliver_count, data.main_product_count]" :color="((data.deliver_count/data.main_product_count)>=1||data.deliver_count==0) ?'green':'blue'"></c-progress>
				</template>
				
				<!--逾期状态-->
				<template #plan_date_state="{data}">
					<c-state type="expectedDate" :value="data.expected_date"></c-state>
				</template>
				
				<!--生产进度%-->
				<template #work_detail_progress="{data}">
					<c-progress v-if="data.scheduling_state == 1" :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
					<span v-else>-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="175"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_order_edit')" v-lock="lock('b_order_edit')" :disabled="!(data.order_state == 2)" icon="tf-edit" @click="editOrder(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_order_query')" v-lock="lock('b_order_edit')" icon="tf-detail" @click="globalDialog('orderDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_order_print')" v-lock="lock('b_order_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_order_edit')" v-lock="lock('b_order_edit')" icon="tf-copy" @click="copyOrder(data)">复制</c-table-button>
						<c-table-button v-if="auth('b_order_transfer')" v-lock="lock('b_order_transfer')" :disabled="!(data.order_state == 2)" icon="tf-order" @click="transferWork([{id:data.id}])">转生产工单</c-table-button>
						<c-table-button v-if="auth('b_order_analysis')" v-lock="lock('b_order_analysis')" :disabled="!(data.order_state == 2)" icon="tf-order-plan" @click="$refs.orderScheduling.open({id:data.id})">排产分析</c-table-button>
						<c-table-button v-if="auth('b_order_transfer_assemble')" v-lock="lock('b_order_transfer_assemble')" :disabled="!(data.order_state == 2)" icon="tf-order-trans" @click="transferAssemble(data)">转装配工单</c-table-button>
						<c-table-button v-if="auth('b_order_deliver')" v-lock="lock('b_order_deliver')" :disabled="!(data.order_state == 2)" icon="tf-deliver" @click="addDeliverOrder(data.id)">发货</c-table-button>
						<c-table-button v-if="auth('b_order_return_create')" v-lock="lock('b_order_return_create')" :disabled="!(data.deliver_count > 0)" icon="tf-return-goods" @click="addReturnOrder(data.id)">退货</c-table-button>
						<c-table-button v-if="auth('b_order_edit')" v-lock="lock('b_order_edit')" :disabled="!(data.order_state != 2)" icon="tf-start" @click="editState(data, 2)">开始</c-table-button>
						<c-table-button v-if="auth('b_order_edit')" v-lock="lock('b_order_edit')" :disabled="!(data.order_state == 2)" icon="tf-finish" @click="editState(data, 3)">完成</c-table-button>
						<c-table-button v-if="auth('b_order_edit')" v-lock="lock('b_order_edit')" :disabled="!(data.order_state == 2)" icon="tf-pause" @click="editState(data, 5)">暂停</c-table-button>
						<c-table-button v-if="auth('b_order_edit')" v-lock="lock('b_order_edit')" :disabled="!(data.order_state != 4)" icon="tf-cancel" @click="editState(data, 4)">取消</c-table-button>
						<c-table-button v-if="auth('b_order_delete')" v-lock="lock('b_order_delete')" icon="tf-trash" color="red" @click="removeOrder(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--创建、编辑销售订单信息弹窗-->
			<order-edit ref="orderEdit" @resolve="updateMethod"></order-edit>
			<!-- 排产分析 -->
			<order-scheduling ref="orderScheduling" @resolve="$refs.view.refresh()"></order-scheduling>
		</module>
	</page>
</template>

<script>
	import orderEdit from '@/pages/sales/order_edit.vue'
	import orderScheduling from '@/pages/sales/order_scheduling.vue'
	import {mapState} from 'vuex'

	export default {
		components: {
			orderEdit,
			orderScheduling
		},
		
		data() {
			return {
				editFlag: false,
                workType: 1,
                view_id: 10001
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['salesOrderStateDic','schedulingStateDic','occStatedic'])
		},
		
		methods: {
			/*******搜索【客户】下拉框信息*****************/
			searchCustomer(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CUSTOMER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			updateMethod(){
				//修改
				if(this.editFlag){
					this.$refs.view.refresh();
				}else{
					this.$refs.view.update();
				}
			},
			
			/******新建/编辑订单*******/
			editOrder(data) {
				if(data){
					this.editFlag = true;
				}else{
					this.editFlag = false;
				}
				this.$refs.orderEdit.open(data);
			},
			
			/******复制订单*******/
			copyOrder(data) {
				this.$refs.orderEdit.open(data, true);
			},

			/******订单发货*******/
            addDeliverOrder(orderId) {
				this.globalDialog('orderDeliverEdit', {
					data: {
						orderId
					}
				}, this.$refs.view.update);
			},
			
			/******订单退货*******/
            addReturnOrder(orderId) {
				this.globalDialog('orderReturnEdit', {
					data: {
						orderId
					}
				}, this.$refs.view.update);
			},
			
			/******修改订单状态************/
			editState(data, order_state){
				this.request({
					url: '/order/editState',
					data: {
						id: data.id, 
						order_state: order_state,
					},
					loading: true,
					success: data => {
						var mess = '';
						if(order_state == 2){
							mess = '修改为「执行中」状态成功';
						}else if(order_state == 3){
							mess = '修改为「已完成」状态成功';
						}else if(order_state == 4){
							mess = '修改为「取消」状态成功';
						}
						
						this.$message({
							message: mess,  // 提示内容,
							type: 'success'
						});
						//刷新
						this.$refs.view.refresh();
					}
				});
			},

			/******删除订单************/
			removeOrder(data){
				this.$confirm({
					message:'确认删除销售订单【'+data.order_code+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/order/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******转生产工单******/
			transferWork(selectData) {
				
				//方式一（只包含订单产品）
				this.request({
					url: '/order/product',
					data: {
						order_ids: selectData.map(data => data.id)
					},
					success: data => {
						this.orderProduct = data.filter(item => item.product_source == 1 || item.product_source == 3).map(item => {
							item.order_product_id = item.id;
							item.unit_count = item.unit_count || 1;
							item.ref_type = 1;
							return item;
						});
						
						this.globalDialog('batchWorkEdit', {
							data: {
								ref_type: 1,
								orderProductList: this.orderProduct
							}
						},
						()=>{
							this.$refs.view.refresh();
						});
					}
				})
				
				//方式二（含订单产品及使用到的bom）
				// this.globalDialog('orderProductSelector', {
				// 	data: {
				// 		orderList: selectData
				// 	}
				// }, data => {
				// 	this.globalDialog('batchWorkEdit', {
				// 		data: {
				// 			ref_type: 1,
				// 			orderProductList: data
				// 		}
				// 	});
				// });
			},
			
			//转装配工单
			transferAssemble(selectData) {
				this.request({
					url: '/order/productBom',
					data: {
						product_source: [1],		//只查询自产产品
						order_ids: [selectData.id]
					},
					success: data => {
						if(data != null && data.length > 0 && data[0].childProduct != null && data[0].childProduct.length > 0){
							this.orderProduct = data[0].childProduct.filter(item => item.product_source == 1 || item.product_source == 3).map(item => {
								item.order_product_id = item.id;
								item.unit_count = item.unit_count || 1;
								item.ref_type = 1;
								return item;
							});
							this.globalDialog('assembleEdit', {
								props: {
									ref_type: 1,
									ref_id: selectData.id,
									orderProductList: this.orderProduct
								}
							},
							()=>{
								this.$refs.view.refresh();
							});
						}else{
							this.$message({
								message:'没有可以转单的产品',  // 提示内容,
								type: 'error'
							});
						}
					}
				})
			},
			
			/******库存占用状态*********/
			occStateHandle(state, next, row) {
				this.request({
					url: '/order/editOccState',
					data: {
						id: row.id,
						occ_state: state ? 1 : 2
					},
					success: data => {
						row.occ_date = data
						next();
					}
				})
			},

            /*******导入数据************/
            importData() {
                this.$refs.view.excelImport(Object.assign({}, {
                    view_id: this.view_id
                }));
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>